// angular
import { Component, input } from '@angular/core';

@Component({
  selector: 'pwj-tooltip',
  standalone: true,
  imports: [],
  templateUrl: './tooltip.component.html',
  styleUrl: './tooltip.component.scss',
})
export class TooltipComponent {
  public direction!: string;

  // inputs
  tooltipText = input.required<string>();
  showsTooltip = input<boolean>(true);
  topPosition = input<number>(20);
  leftPosition = input<number>(20);
}
